import { IWorkspaceContext } from "@hooks/useWorkspace";
import { createContext } from "react";

const WorkspaceContext = createContext({} as IWorkspaceContext);

export default WorkspaceContext;